/** Whether a profile is the District88 official account (shows Official tag, not Employee). */

export type ProfileBadgeSource = {
  is_official_account?: boolean | null;
  is_employee?: boolean | null;
  username?: string | null;
};

export function profileIsOfficial(profile: ProfileBadgeSource | null | undefined): boolean {
  if (!profile) return false;
  if (profile.is_official_account) return true;
  return profile.username?.toLowerCase().trim() === 'district88';
}

export function profileShowsEmployeeBadge(profile: ProfileBadgeSource | null | undefined): boolean {
  return !!(profile?.is_employee) && !profileIsOfficial(profile);
}
